import { w as writable } from "./index2.js";
const token = writable(typeof window !== "undefined" ? localStorage.token : null);
const user = writable(typeof window !== "undefined" ? sessionStorage.user : null);
export {
  token as t,
  user as u
};
//# sourceMappingURL=auth.js.map
